export const getters = {
  isLoading: (state: any) => {
    return state.loadingStack.length !== 0
  }
}
